module.exports = __webpack_public_path__ + "img/avatar7.63cf1c9b.png";